<script>
import moment from 'moment'

export default {
  name: 'ClinicInvoiceMixin',
  data () {
    return {
      // khớp ClinicInvoiceEntity.STATUS_* ở backend
      INVOICE_STATUS: {
        DRAFT: 0,
        AWAITING_PAYMENT: 1,
        PROCESSING: 2,
        PAID: 3,
        FAILED: 4,
        VOID: 5
      },
      INVOICE_STATUS_LABEL: {
        0: 'Draft',
        1: 'Awaiting payment',
        2: 'Processing',
        3: 'Paid',
        4: 'Failed',
        5: 'Void'
      }
    }
  },
  methods: {
    /** cent -> "$1,250.00" */
    formatMoney (cents) {
      const value = (Number(cents) || 0) / 100
      return '$' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatPeriod (period) {
      return period ? moment(period, 'YYYY-MM').format('MMM YYYY') : ''
    }
  }
}
</script>
